<template>
    <div class="main-menu ux-element light-sand">
        <div class="inner-menu spacing-alternative">
            <div class="menu-header">
                <langMenu />
            </div>

            <div class="menu-navigation">
                <div class="navigation-container">
                    <MenueWidget :menuType="'main'" :class="{ activated : isActivated }" />
    
                    <nav class="social-navigation">
                        <ul>
                            <li>
                                <a href="https://de.linkedin.com/company/we-create-experiences" title="LinkedIn" target="_blank">LinkedIn</a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/walbertschmitz/" title="Instagram" target="_blank">Instagram</a>
                            </li>
                            <li>
                                <a href="https://www.youtube.com/c/Walbert-schmitzDe" title="YouTube" target="_blank">YouTube</a>
                            </li>
                            <li>
                                <a href="https://www.pinterest.de/walbertschmitz/" title="Pinterest" target="_blank">Pinterest</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            <div class="menu-footer">
                <LoginWidget />
                
                <div class="toggler big-toggler">
                    <div class="label-container">
                        <span class="switch-label switch-off" :class="{'active': !darkmode}" @click="toggleDarkmode(false)">Light Mode</span>
                        <span class="switch-label switch-on" :class="{'active': darkmode}" @click="toggleDarkmode(true)">Dark Mode</span>
                    </div>
                    
                    <div class="switch-container">
                        <label for="darkmode-toggler" class="switch">
                            <input id="darkmode-toggler" type="checkbox" :checked="darkmode" @change="toggleDarkmode()">
                            <span class="slide-pin"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { MathHelper } from "~/composables/Classes/Helper"
    import { useRequestStore } from '@/stores/requests'

    const { $iframeMessenger } = useNuxtApp()
    
    const localForage = useLocalForage()
    const globalsStore = useGlobalsStore()
    const requestStore = useRequestStore()

    const { darkmode } = storeToRefs(requestStore)
    const { menuState } = storeToRefs(globalsStore)

    const isActivated = computed(() => {
        if(menuState.value) {
            // console.log("true")
            setTimeout(() => {
                return true
            }, 500)
        }
    })

    const toggleDarkmode = async <Function>(lightmode?: boolean) => {
        const htmlRoot = document.querySelector('html') as HTMLElement

        if (lightmode === true) {
            MathHelper.mutateEle(htmlRoot, 'add-attribute', 'darkmode')
        } else if (lightmode === false) {
            MathHelper.mutateEle(htmlRoot, 'remove-attribute', 'darkmode')
        } else {
            MathHelper.mutateEle(htmlRoot, 'toggle-attribute', 'darkmode')
        }

        if (htmlRoot.hasAttribute('darkmode')) {
            // await localForage.setItem('darkmode', true)
            localStorage.setItem('darkmode', 'true')
            requestStore.toggleDarkmode(true)
            $iframeMessenger.post('wallpaper-iframe', 'darkmode', true)
        } else {
            // await localForage.removeItem('darkmode')
            localStorage.removeItem('darkmode')
            requestStore.toggleDarkmode(false)
            $iframeMessenger.post('wallpaper-iframe', 'darkmode', false)
        }
    }

    if (localStorage.getItem('darkmode')) {
        requestStore.toggleDarkmode(true)
    }
</script>